import { Injectable } from '@angular/core';
import numeral from 'numeral';

@Injectable({
    providedIn: 'root',
})

export class MonNumberService {
    constructor () { }

    transformNumber (value: number, format: string): string {
        return numeral(value).format(format);
    }

}
